import { CommunicationIntegrationKind } from "@/types/communication-integration";
import { CommunicationChannelKind } from "@/types/messaging-channel-config";

export interface MissingIntegrationError {
  channel?: CommunicationChannelKind;
  missingIntegration: CommunicationIntegrationKind;
  missingField?: string;
}

const INTEGRATION_KINDS: readonly CommunicationIntegrationKind[] = [
  "EMAIL",
  "TWILIO",
  "META_WHATSAPP",
];

const isIntegrationKind = (
  value: unknown,
): value is CommunicationIntegrationKind =>
  typeof value === "string" &&
  INTEGRATION_KINDS.includes(value as CommunicationIntegrationKind);

interface ErrorLike {
  details?: Record<string, unknown>;
  response?: { data?: Record<string, unknown> };
}

export const extractMissingIntegrationError = (
  error: unknown,
): MissingIntegrationError | null => {
  if (!error || typeof error !== "object") return null;
  const e = error as ErrorLike;
  const body = e.details ?? e.response?.data ?? null;
  if (!body || typeof body !== "object") return null;

  const missingIntegration = (body as Record<string, unknown>)
    .missingIntegration;
  if (!isIntegrationKind(missingIntegration)) return null;

  const channelRaw = (body as Record<string, unknown>).channel;
  const channel =
    typeof channelRaw === "string"
      ? (channelRaw as CommunicationChannelKind)
      : undefined;

  const missingFieldRaw = (body as Record<string, unknown>).missingField;
  const missingField =
    typeof missingFieldRaw === "string" ? missingFieldRaw : undefined;

  return { channel, missingIntegration, missingField };
};
